import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { FILL_RATE_CHART_ENDPOINT } from '../stock-chart-endpoints';

export const FILL_RATE_TOTAL_METRIC_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.FILL_RATE_TOTAL_METRIC,
    chartType: ChartRendererType.METRIC,
    endpoint: FILL_RATE_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }]
};
